import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { http, formatError } from "@/lib/api";
import { PostView } from "@/pages/Blog";

// Private preview of the working copy in the real article design (noindex, admin only).
export const BlogPreview = () => {
  const { id } = useParams();
  const [p, setP] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    http.get(`/admin/posts/${id}`).then((r) => setP({ ...r.data, ...(r.data.draft || {}) })).catch((e) => setErr(formatError(e)));
  }, [id]);
  if (err) return <p className="p-10 text-center font-semibold text-red-600">{err}</p>;
  if (!p) return <div className="flex min-h-screen items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-[#7C3AED]" /></div>;
  return (
    <div data-testid="blog-preview">
      <div className="sticky top-0 z-[60] bg-[#FF7043] px-4 py-2 text-center text-sm font-extrabold text-[#13052A]" data-testid="blog-preview-banner">Private preview. Visitors cannot see this version until it is published or updated.</div>
      <PostView p={p} preview />
    </div>
  );
};
